export const FETCH_APP_STATE = '/getappstate';


